import { useState } from "react";
import { useLogin } from "@refinedev/core";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useBrand } from "@/hooks/useBrand";

export function Login() {
  const brand = useBrand();
  const { mutate: login } = useLogin();
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [otpWrong, setOtpWrong] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(null);

  return (
    <div className="login-page min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-[380px]">
        <div className="login-logo-shift flex items-center gap-2.5 mb-6 justify-center">
          <img src={brand.logoUrl} alt={brand.name} className="w-9 h-9 object-contain" />
          <div className="brand-wordmark text-xl">{brand.name}</div>
        </div>
        <div className="login-card rounded-lg p-6">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setBusy(true);
              setOtpWrong(false);
              setLoginError(null);
              login(
                { email, password, otp: otp || undefined },
                {
                  onSettled: () => setBusy(false),
                  onSuccess: (data: any) => {
                    if (data?.error?.name === "otp_required") {
                      setOtpWrong(true);
                      document.getElementById("cordite-otp")?.focus();
                    } else if (data?.success === false) {
                      setLoginError(data?.error?.message || "Invalid email or password.");
                    }
                  },
                  onError: (err: any) => {
                    if (err?.name === "otp_required") {
                      setOtpWrong(true);
                      document.getElementById("cordite-otp")?.focus();
                    } else {
                      setLoginError(err?.message || "Invalid email or password.");
                    }
                  },
                },
              );
            }}
            className="flex flex-col gap-3"
          >
            <label htmlFor="cordite-email" className="text-xs text-muted-foreground">Email
              <Input id="cordite-email" name="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" />
            </label>
            <label htmlFor="cordite-password" className="text-xs text-muted-foreground">Password
              <Input id="cordite-password" name="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" />
            </label>
            {/* Always on the form: TFA is enforced instance-wide, so the code
                is the common case, and hiding it until a failed submit charged
                every sign-in a round trip. Empty means "this account has no
                authenticator" (a legacy or fixture account). */}
            <label htmlFor="cordite-otp" className="text-xs text-muted-foreground">Authenticator code
              <Input id="cordite-otp" name="otp" type="text" inputMode="numeric" autoComplete="one-time-code" placeholder="If your account has one" value={otp} onChange={(e) => setOtp(e.target.value)} className="mt-1" />
            </label>
            {otpWrong && (
              <div className="text-xs text-destructive">Enter your current 6-digit authenticator code (codes rotate every 30 seconds).</div>
            )}
            {loginError && !otpWrong && (
              <div className="text-xs text-destructive">{loginError}</div>
            )}
            <Button type="submit" disabled={busy} className="mt-1">{busy ? "Signing in..." : "Sign in"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
